import notificationActionTypes from "../actions/notificationActionTypes";

export function notificationReducer(state = {}, action) {
  switch (action.type) {
    case notificationActionTypes.NOTIFICATION_FETCH_PENDING:
      return {
        ...state,
        data: [],
        isPending: true,
        isSuccess: false,
        isError: false,
      };
    case notificationActionTypes.NOTIFICATION_FETCH_SUCCESS:
      return {
        ...state,
        data: action.data,
        isPending: false,
        isSuccess: true,
        isError: false,
      };
    case notificationActionTypes.NOTIFICATION_FETCH_ERROR:
      return {
        ...state,
        data: null,
        isPending: false,
        isSuccess: false,
        isError: true,
      };
    case notificationActionTypes.NOTIFICATION_FETCH_RSS_SUBSCRIPTION_LINK_PENDING:
      return {
        ...state,
        data: [],
        isPending: true,
        isSuccess: false,
        isError: false,
      };
    case notificationActionTypes.NOTIFICATION_FETCH_RSS_SUBSCRIPTION_LINK_SUCCESS:
      return {
        ...state,
        data: action.data,
        isPending: false,
        isSuccess: true,
        isError: false,
      };
    case notificationActionTypes.NOTIFICATION_FETCH_RSS_SUBSCRIPTION_LINK_ERROR:
      return {
        ...state,
        data: null,
        isPending: false,
        isSuccess: false,
        isError: true,
      };
    case notificationActionTypes.NOTIFICATION_COPY_PENDING:
      return {
        ...state,
        data: [],
        isCopyPending: true,
        isCopySuccess: false,
        isCopyError: false,
      };
    case notificationActionTypes.NOTIFICATION_COPY_SUCCESS:
      return {
        ...state,
        data: action.data,
        isCopyPending: false,
        isCopySuccess: true,
        isCopyError: false,
      };
    case notificationActionTypes.NOTIFICATION_COPY_ERROR:
      return {
        ...state,
        message: action.message,
        isCopyPending: false,
        isCopySuccess: false,
        isCopyError: true,
      };
    default:
      return state;
  }
}
